import { useDispatch, useSelector } from '@betty/toolkit/state';
import {
  claimAllStatusRewards,
  selectIsClaimingAllRewards,
} from '../state/status.slice';
import { memo, useCallback } from 'react';
import { Box, Button, useTheme } from '@betty/moonlight';
import { StatusBoxListProps } from './types';
import StatusBoxListItem from './StatusBoxListItem';
import Animated, { LinearTransition } from 'react-native-reanimated';
import { StatusRewardType } from '../state';
import { ListRenderItem } from 'react-native';

function StatusBoxList({ status }: StatusBoxListProps) {
  const dispatch = useDispatch();
  const isClaimingAllRewards = useSelector(selectIsClaimingAllRewards);

  const handleOpenAll = useCallback(async () => {
    await dispatch(claimAllStatusRewards());
    // TODO: Animate coins
  }, [dispatch]);

  const renderItem = useCallback<ListRenderItem<StatusRewardType>>(
    ({ item }) => <StatusBoxListItem reward={item} />,
    [status],
  );

  const keyExtractor = useCallback(
    ({ rewardId }: StatusRewardType) => rewardId.toString(),
    [status],
  );

  const theme = useTheme();

  if (!status) {
    return null;
  }

  const { pendingRewards } = status;

  return (
    <Box width="100%" alignItems="center" gap="space-400">
      {pendingRewards?.length === 1 ? (
        <StatusBoxListItem isOnlyItem reward={pendingRewards[0]} />
      ) : (
        <>
          <Animated.FlatList
            data={pendingRewards}
            renderItem={renderItem}
            keyExtractor={keyExtractor}
            itemLayoutAnimation={LinearTransition}
            style={{ maxHeight: 120, width: '100%' }}
            contentContainerStyle={{ gap: theme.spacing['space-200'] }}
          />
          <Button
            width="100%"
            variant="primary"
            locNS="status"
            locKey="status_boxes_open_all_cta"
            onPress={handleOpenAll}
            loading={isClaimingAllRewards}
          />
        </>
      )}
    </Box>
  );
}

export default memo(StatusBoxList);
